import React, { useState } from 'react';
import './DashboardUserTable.css';
import UserDetailPopup from './UserDetailPopup';
import { Input } from './ui';
import { useT } from '../i18n';

const messages = {
  title: { tr: 'Kullanıcılar', en: 'Users' },
  search: { tr: 'Kullanıcı ara', en: 'Search users' },
  colName: { tr: 'İSİM', en: 'NAME' },
  colEmail: { tr: 'E-POSTA', en: 'EMAIL' },
  colGroup: { tr: 'GRUP', en: 'GROUP' },
};

const MAX_VISIBLE_GROUPS = 2;

export default function DashboardUserTable({ users }) {
  const [selectedUser, setSelectedUser] = useState(null);
  const [search, setSearch] = useState('');
  const { t } = useT(messages);

  const groupsOf = (user) => (user.groups && user.groups.length > 0 ? user.groups : [user.group].filter(Boolean));

  const filteredUsers = users.filter(user =>
    (user.displayName || '').toLowerCase().includes(search.toLowerCase()) ||
    (user.Mail || user.mail || '').toLowerCase().includes(search.toLowerCase()) ||
    groupsOf(user).some(g => g.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <>
      <div className="mini-table-card dashboard-user-table">
        <div className="dashboard-table-head">
          <h2>{t('title')}</h2>
          <Input
            type="text"
            className="dashboard-user-table-search"
            placeholder={t('search')}
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <table className="data-table data-table-scroll">
        <thead>
          <tr>
            <th>{t('colName')}</th>
            <th>{t('colEmail')}</th>
            <th>{t('colGroup')}</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map(user => {
            const groups = groupsOf(user);
            const visibleGroups = groups.slice(0, MAX_VISIBLE_GROUPS);
            const extraCount = groups.length - visibleGroups.length;
            return (
              <tr key={user.id} onClick={() => setSelectedUser(user)} className="clickable-row">
                <td>{user.displayName}</td>
                <td>{user.Mail || user.mail}</td>
                <td>{visibleGroups.join(', ')}{extraCount > 0 ? ` +${extraCount}` : ''}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {selectedUser && (
        <UserDetailPopup
          user={selectedUser}
          onClose={() => setSelectedUser(null)}
        />
      )}
      </div>
    </>
  );
}
